const PickLocationsTile = ({text, value, drop, bordercolor, bgcolor}) => {
    return (
        <div className={drop ? "pickLocationTitledrop backgroundColor-Type3 font-small" : (bgcolor ? "pickLocationTitle font-small" : "pickLocationTitle backgroundColor-Type3 font-small")} style={{"backgroundColor":bgcolor?bgcolor:"", "border":bordercolor?"1px solid "+bordercolor:""}}>
            <span className="font-xsmall textColor-Type8">{text}</span>
            <span className={drop ? "font-xsmall textColor-Type5 font-weight-bold" : "font-xsmall textColor-Type1 font-weight-bold"}>{value ? value : '-'}</span>
        </div>
    )
}
export default PickLocationsTile;